import ContentLayout from "../layout/ContentLayout";
import { Navigate } from "react-router-dom";

const ProtectedRoutes = ({ setAuthToken, authToken }) => {
    return (
        <>
            {
                authToken && authToken !== null && authToken !== undefined ? 
                <ContentLayout setAuthToken={setAuthToken} />
                :
                <Navigate to="login"/>
            }
        </>
    )
}

export default ProtectedRoutes;